// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e9e65447","691":"116df40a"}[chunkId] + ".chunk.js";
};